<template>
    <vx-card id="loader">
        <div class="vx-row mb-2">
            <vs-col vs-offset="0" vs-type="flex" vs-justify="left" vs-align="center">
                <h4 class="float-left">Коэффы автомикробиддинга по кампании {{ this.campaignId }}</h4>
            </vs-col>
        </div>
        <div class="vx-row mb-2">
            <div class="vx-col w-1/4">
                <label class="vs-input--label"> Группировки </label>
                <v-select :clearable="false" :options="this.dicts.groups" placeholder="Выберите группировку"
                    label="name" class="w-full" v-bind:class="{ 'select-error': !!errors.groupBy }"
                    v-model="form.groupBy" :reduce="(g) => g.colm">
                </v-select>
            </div>

            <div class="vx-col w-1/4 mb-1" v-if="this.form.groupBy == 'sites'">
                <vs-input v-model="form.siteId" autocomplete="off" label="ID сайта" placeholder="Введите ID сайта..."
                    class="mt-1 w-full" />
            </div>
            <div class="vx-col w-1/4 mb-1" v-if="this.form.groupBy == 'subsDays'">
                <vs-input v-model="form.subDaysGroup" autocomplete="off" label="Группа дней"
                    placeholder="Введите группу дней..." class="mt-1 w-full" />
            </div>
            <div class="vx-col w-1/2">
                <label class="vs-input--label"> Интервал</label>
                <div class="date-p w-full">
                    <date-picker :not-after="disabledAfter" :clearable="false" range v-model="dateInterval"
                        type="datetime" format="YYYY-MM-DD HH:mm:ss" placeholder="Интервал времени" :lang="'ru'"
                        :firstDayOfWeek="1" class="date-p vs-lg-9 float-left">
                    </date-picker>
                </div>
            </div>
            <div class="vx-col w-1/4">
                <label class="vs-input--label"> SSP </label>
                <v-select multiple :options="dicts.sspTypes" label="name" placeholder="Выберите SSP" class="w-full"
                    v-model="form.sspTypeIds" :reduce="(s) => s.id">
                </v-select>
            </div>
            <div class="vx-col mb-1">
                <div class="vx-col w-full mt-6">
                    <vs-button color="success" @click="loadData()" type="filled"> Получить
                    </vs-button>
                    <vs-button class="ml-5" type="filled" @click="backToList()">
                        Назад
                    </vs-button>
                </div>
            </div>
        </div>

        <vs-table :data="siteItems" :max-items="pageSize" class="mt-5" v-if="isSiteItemsVisible">
            <template slot="header"> </template>
            <template slot="thead">
                <vs-th>Сайт</vs-th>
                <vs-th>Клики</vs-th>
                <vs-th>Конверсии</vs-th>
                <vs-th>Расход DSP </vs-th>
                <vs-th>Цена клика DSP</vs-th>
                <vs-th>Цена клика Объявл.</vs-th>
                <vs-th>СR</vs-th>
                <vs-th>Факт. ср. коэфф. с норм.</vs-th>
                <vs-th>Тек. коэфф. с норм.</vs-th>
            </template>

            <template v-for="(row, indextr) in siteItems">
                <vs-tr>
                    <vs-td> {{ row.siteId }}</vs-td>
                    <vs-td> {{ row.clicksCount }}</vs-td>
                    <vs-td>{{ row.leadsCount | formatNumber(3) }}</vs-td>
                    <vs-td> {{ row.dspFlow | formatNumber(2) }}</vs-td>
                    <vs-td>{{ row.clickPriceDsp | formatNumber(3) }}</vs-td>
                    <vs-td>{{ row.clickPriceAd | formatNumber(3) }}</vs-td>
                    <vs-td>{{ row.conversionRate | formatNumber(3) }}</vs-td>
                    <vs-td>{{ row.avgCoeffFact | formatNumber(3) }}</vs-td>
                    <vs-td>{{ row.kCampaignFinal | formatNumber(3) }}</vs-td>
                </vs-tr>
            </template>
            <vs-tr v-if="this.siteItemsSummary" ><vs-td> Итого</vs-td>
                <vs-td> {{ this.siteItemsSummary.clicksCount }}</vs-td>
                <vs-td>{{ this.siteItemsSummary.leadsCount | formatNumber(3) }}</vs-td>
                <vs-td> {{ this.siteItemsSummary.dspFlow | formatNumber(2) }}</vs-td>
                <vs-td>{{ this.siteItemsSummary.clickPriceDsp | formatNumber(3) }}</vs-td>
                <vs-td>{{ this.siteItemsSummary.clickPriceAd | formatNumber(3) }}</vs-td>
                <vs-td>{{ this.siteItemsSummary.conversionRate | formatNumber(3) }}</vs-td>
                <vs-td>{{ this.siteItemsSummary.avgCoeffFact | formatNumber(3) }}</vs-td>
                <vs-td>{{ this.siteItemsSummary.kNorm | formatNumber(3) }}</vs-td></vs-tr>
        </vs-table>

        <vs-table :data="subDaysItems" :max-items="pageSize" class="mt-5" v-if="isSubDaysItemsVisible">
            <template slot="header"> </template>
            <template slot="thead">
                <vs-th>Группа дней</vs-th>
                <vs-th>Клики</vs-th>
                <vs-th>Конверсии</vs-th>
                <vs-th>Расход DSP </vs-th>
                <vs-th>Цена клика DSP</vs-th>
                <vs-th>Цена клика Объявл.</vs-th>
                <vs-th>СR</vs-th>
                <vs-th>Факт. ср. коэфф. с норм.</vs-th>
                <vs-th>Тек. коэфф. с норм.</vs-th>
            </template>

            <template v-for="(row, indextr) in subDaysItems">
                <vs-tr>
                    <vs-td>{{ row.daysGroup }}</vs-td>
                    <vs-td>{{ row.clicksCount }}</vs-td>
                    <vs-td>{{ row.leadsCount | formatNumber(3) }}</vs-td>
                    <vs-td>{{ row.dspFlow | formatNumber(2) }}</vs-td>
                    <vs-td>{{ row.clickPriceDsp | formatNumber(3) }}</vs-td>
                    <vs-td>{{ row.clickPriceAd | formatNumber(3) }}</vs-td>
                    <vs-td>{{ row.conversionRate | formatNumber(3) }}</vs-td>
                    <vs-td>{{ row.avgCoeffFact | formatNumber(3) }}</vs-td>
                    <vs-td>{{ row.kCampaignFinal | formatNumber(3) }}</vs-td>
                </vs-tr>
            </template>
            <vs-tr v-if="this.subDaysItemsSummary"><vs-td> Итого</vs-td>
                <vs-td> {{ this.subDaysItemsSummary.clicksCount }}</vs-td>
                <vs-td>{{ this.subDaysItemsSummary.leadsCount | formatNumber(3) }}</vs-td>
                <vs-td> {{ this.subDaysItemsSummary.dspFlow | formatNumber(2) }}</vs-td>
                <vs-td>{{ this.subDaysItemsSummary.clickPriceDsp | formatNumber(3) }}</vs-td>
                <vs-td>{{ this.subDaysItemsSummary.clickPriceAd | formatNumber(3) }}</vs-td>
                <vs-td>{{ this.subDaysItemsSummary.conversionRate | formatNumber(3) }}</vs-td>
                <vs-td>{{ this.subDaysItemsSummary.avgCoeffFact | formatNumber(3) }}</vs-td>
                <vs-td>{{ this.subDaysItemsSummary.kNorm | formatNumber(3) }}</vs-td></vs-tr>
        </vs-table>
        <vs-pagination v-if="pagesTotal > 1" :max="5" :total="pagesTotal" v-model="page" class="mt-3"></vs-pagination>
    </vx-card>
</template>


<script>
import vSelect from 'vue-select';
import DatePicker from 'vue2-datepicker';
import qs from 'qs';
import axios from 'axios';
const endPeriodDefault = new Date();


export default {
    name: 'automicrobidding-monitoring-coeffs',
    props: ['campaignId'],
    data() {
        return {
            disabledAfter: endPeriodDefault,

            popupIsVisible: false,
            popupContent: '',
            selectedDetail: undefined,
            selectedRow: undefined,
            isLogSidCid: false,

            siteItems: [],
            siteItemsSummary: undefined,
            isSiteItemsVisible: true,
            subDaysItems: [],
            subDaysItemsSummary: undefined,
            isSubDaysItemsVisible: false,

            dicts: {
                groups: [],
                sspTypes: [],
            },

            dateInterval: undefined,

            form: {
                campaignId: '',
                groupBy: [],
                siteId: undefined,
                subDaysGroup: undefined,
                orderBy: 'clicks_count',
                isOrderAsc: false,
            },
            errors: {
            },
            page: 1,
            pageSize: 25,
            pagesTotal: 1
        };
    },
    methods: {
        loadDicts() {
            this.axios
                .all([this.axios.get('autoMicrobiddingMonitoring/coeff/dicts')])
                .then(
                    axios.spread((dicts) => {
                        this.dicts.groups = dicts.data.groups;
                        this.form.groupBy = this.dicts.groups[0].colm;

                        this.dicts.sspTypes = dicts.data.sspTypes;
                    })
                )
                .catch((err) => {
                    this.$vs.notify({
                        title: 'Ошибка!',
                        text: 'Ошибка загрузки словарей.',
                        color: 'danger'
                    });
                })
                .finally(() => {
                    // this.$vs.loading.close('#loader > .con-vs-loading');
                });
        },
        loadData() {
            this.isSiteItemsVisible = false;
            this.isSubDaysItemsVisible = false;
            switch (this.form.groupBy) {
                case 'sites':
                    this.loadAutoMicrobiddingCoeffsSite();
                    break;
                case 'subsDays':
                    this.loadAutoMicrobiddingCoeffsSubDays();
                    break;
            }
        },
        backToList() {
            this.$vs.loading({
                container: '#loader',
                type: 'sound'
            });

            window.location.href = '/debugging/automicrobidding-monitoring';
        },


        loadAutoMicrobiddingCoeffsSite() {
            var params = {
                startPeriod: this.form.date_time_from,
                endPeriod: this.form.date_time_to,
                campaignId: this.campaignId,
                sspTypeIds: this.form.sspTypeIds ? this.form.sspTypeIds : undefined,
                siteId: this.form.siteId,

                page: this.page,
                pageSize: this.pageSize,
                orderBy: this.form.orderBy,
                isOrderAsc: this.form.isOrderAsc,
            };

            this.items = [];
            this.$vs.loading({
                container: '#loader',
                type: 'sound'
            });
            this.axios
                .all([
                    this.axios.get('autoMicrobiddingMonitoring/site-coeffs/', {
                        params: params,
                        paramsSerializer: (params) => {
                            return qs.stringify(params, { arrayFormat: 'repeat' });
                        }
                    })
                ])
                .then(
                    axios.spread((response) => {
                        this.$vs.loading.close('#loader > .con-vs-loading');
                        if (!response || !response.data) {
                            return;
                        }
                        this.siteItems = response.data.items;
                        this.pagesTotal = response.data.totalPages;
                        this.subDaysKNorm = response.data.kNorm;
                        this.siteItemsSummary = response.data.summary;
                        this.isSiteItemsVisible = true;                        
                    })
                )
                .catch((err) => {
                    this.$vs.loading.close('#loader > .con-vs-loading');
                    this.$vs.notify({
                        title: 'Ошибка!',
                        text: 'Ошибка загрузки элементов групп дней подписки: ' + err.response.data,
                        color: 'danger'
                    });
                })
                .finally(() => {
                    this.$vs.loading.close('#loader > .con-vs-loading');
                });
        },
        loadAutoMicrobiddingCoeffsSubDays() {
            var params = {
                startPeriod: this.form.date_time_from,
                endPeriod: this.form.date_time_to,
                campaignId: this.campaignId,
                sspTypeIds: this.form.sspTypeIds ? this.form.sspTypeIds : undefined,
                subDaysGroup: this.form.subDaysGroup,

                page: this.page,
                pageSize: this.pageSize,
                orderBy: this.form.orderBy,
                isOrderAsc: this.form.isOrderAsc,
            };

            this.items = [];
            this.$vs.loading({
                container: '#loader',
                type: 'sound'
            });
            this.axios
                .all([
                    this.axios.get('autoMicrobiddingMonitoring/sub-days-group/', {
                        params: params,
                        paramsSerializer: (params) => {
                            return qs.stringify(params, { arrayFormat: 'repeat' });
                        }
                    })
                ])
                .then(
                    axios.spread((response) => {
                        this.$vs.loading.close('#loader > .con-vs-loading');
                        if (!response || !response.data) {
                            return;
                        }
                        this.subDaysItems = response.data.items;
                        this.pagesTotal = response.data.totalPages;
                        this.siteKNorm = response.data.kNorm;
                        this.subDaysItemsSummary = response.data.summary;
                        this.isSubDaysItemsVisible = true;
                    })
                )
                .catch((err) => {
                    this.$vs.loading.close('#loader > .con-vs-loading');
                    this.$vs.notify({
                        title: 'Ошибка!',
                        text: 'Ошибка загрузки элементов сайтов: ' + err.response.data,
                        color: 'danger'
                    });
                })
                .finally(() => {
                    this.$vs.loading.close('#loader > .con-vs-loading');
                });
        },
        setDefaultValues() {
            let d = new Date();
            let today = this.$moment(d).format('YYYY-MM-DD');
            let endDayStr = today;
            let startDayStr = today;
            this.dateInterval = [startDayStr + ' 00:00:00', endDayStr + ' 23:59:59'];
            this.form.date_time_from = this.$moment(this.dateInterval[0]).format('YYYY-MM-DD 00:00:00');
            this.form.date_time_to = this.$moment(this.dateInterval[1]).format('YYYY-MM-DD 23:59:59');

            this.form.updateDate = today;
            this.form.groupBy = this.groupBy || this.form.groupBy;
        }

    },
    mounted() {
        this.loadDicts();
        this.setDefaultValues();
        this.loadData();
    },
    components: {
        'v-select': vSelect,
        'date-picker': DatePicker
    },
    watch: {
        page: function () {
            this.loadData();
        },
        dateInterval: function (newTime) {
            this.form.date_time_from = this.$moment(newTime[0]).format('YYYY-MM-DD HH:mm:ss');
            this.form.date_time_to = this.$moment(newTime[1]).format('YYYY-MM-DD HH:mm:ss');
        }
    },
    beforeCreate() {
        // Установка заголовка вкладки
        document.title = 'Коэффы автомикробиддинга по кампании';
    }
};
</script>

<style>
.date-p {
    display: block;
}

.logs-popup .vs-popup {
    width: 1000px !important;
    height: auto !important;
}
</style>
<style scoped>
div>>>.vs-pagination-primary {
    margin-top: 10px;
}

.no-padding {
    padding: 6px !important;
    margin-left: 10px;
    margin-top: -5px;
}
</style>
